module.exports = __webpack_public_path__ + "static/media/mock2.1f97e708.svg";